import { makeAutoObservable } from "mobx";
import { makePersistable, hydrateStore } from "mobx-persist-store";

type DAFilters = {
    date: string;
};

export class DigitalArchiveStore {
    rootStore: any;

    // Add/Edit Modal
    addNewModal: boolean = false;

    // View Modal
    viewFileModal: boolean = false;

    // Navigation
    activeParentId: string = "";
    folderBreadCrumbs: any[] = [];

    // Selected Files
    activeFileorFolder: any = {};
    activeViewFile: any = {};

    // Search
    searchQuery: string = "";

    // Filters
    daFilters: DAFilters = {
        date: "",
    };

    da_filter_modal: boolean = false;

    constructor(rootStore: any) {
        this.rootStore = rootStore;

        makeAutoObservable(this);

        makePersistable(this, {
            name: "folderBreadCrumbs",
            properties: ["folderBreadCrumbs"],
            storage: window.localStorage,
        });

        hydrateStore(this);
    }

    // ============================================================
    // Generic Store Property Updater
    // ============================================================

    update_DAStoreProp = (prop: string, value: any) => {
        switch (prop) {
            case "addNewModal":
                this.addNewModal = value;
                break;

            case "activeParentId":
                this.activeParentId = value;
                break;

            case "activeFileorFolder":
                this.activeFileorFolder = value;
                break;

            case "activeViewFile":
                this.activeViewFile = value;
                break;

            case "viewFileModal":
                this.viewFileModal = value;
                break;

            case "da_filter_modal":
                this.da_filter_modal = value;
                break;

            case "searchQuery":
                this.searchQuery = value;
                break;

            default:
                break;
        }
    };

    // ============================================================
    // View File
    // ============================================================

    openViewFile = (file: any) => {
        this.activeViewFile = file;
        this.viewFileModal = true;
    };

    closeViewFile = () => {
        this.activeViewFile = {};
        this.viewFileModal = false;
    };

    // ============================================================
    // Breadcrumbs
    // ============================================================

    resetFolderBreadCrumbs = () => {
        this.folderBreadCrumbs = [];
    };

    update_folder_breadcrumbs = (crumbs: any[]) => {
        this.folderBreadCrumbs = crumbs;
    };

    // ============================================================
    // Filters
    // ============================================================

    update_da_filters = (data: DAFilters) => {
        this.daFilters = data;
    };

    async get_files_and_folders(payload: any) {
        return await this.rootStore.api.post("dropbox/search", payload);
    }

    async add_file_to_digital_archive(payload: any) {
        return await this.rootStore.api.post("dropbox/add_doc_list", payload);
    }

    async edit_file_to_digital_archive(payload: any) {
        return await this.rootStore.api.post("dropbox/update_doc", payload);
    }

    async delete_file_or_folder(payload: any) {
        return await this.rootStore.api.post("dropbox/del_doc", payload);
    }
}
